import React from 'react'
import Title from '../components/Title'
import EducationItem from '../components/EducationItem'
import phone from '../images/phone.svg';

const Education = () => {
    return (
        <div>
            <div className="title">
                <Title title={'Education'} span={'Education'} />
            </div>

            <div className="EducationPage">
                <div className="education-sect">
                    <EducationItem icon={phone} text1={'Electronics & Communication Engineering (ECE)'} text2={'Jaypee Institute of Information Technology'}  text3={'A-10 Sector 62, Noida Uttar Pradesh'} title={'Bachelor of Technology (B. Tech.)'}/>
                </div>
            </div>
            
        </div>
    )
}

export default Education
